import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';

/**
 * Keeps `document.title` in step with the page. Until this existed every tab,
 * bookmark and native share sheet said "Hungery", whatever was on screen.
 *
 * AppComponent applies a static title on each navigation; pages with their own
 * data (a business, a city listing) call `set()` once they know the name.
 */
@Injectable({
  providedIn: 'root',
})
export class PageTitleService {
  static readonly BRAND = 'Hungery';

  private static readonly STATIC_TITLES: Record<string, string> = {
    'listing': 'Restaurants',
    'why-hungery': 'Why Hungery',
    'pricing': 'Pricing',
    'get-in-touch': 'Get in Touch',
    'personalize-plan': 'Personalize your plan',
    'onboarding': 'Register your business',
    'personal-details': 'My Profile',
    'edit-personal-details': 'Edit Profile',
    'gallery': 'Gallery',
    'articles': 'Articles',
    'articles/my': 'My Articles',
    'articles/liked': 'Liked Articles',
    'article-edit': 'Edit Article',
    'article-preview': 'Article',
    'privacy': 'Privacy Policy',
    'pre-registration': 'Pre-registration',
    'pre-registration-review': 'Pre-registration Review',
  };

  constructor(private title: Title) {}

  /** "Page · Hungery", or just the brand when `page` is empty. */
  set(page?: string | null): void {
    const text = (page ?? '').toString().trim();
    this.title.setTitle(text ? `${text} · ${PageTitleService.BRAND}` : PageTitleService.BRAND);
  }

  /** Static title for a route path such as "/articles/liked" (query/hash already stripped). */
  setForUrl(url: string): void {
    const segments = url.split('/').filter(Boolean);
    const twoLevel = segments.slice(0, 2).join('/');
    const oneLevel = segments[0] ?? '';
    this.set(PageTitleService.STATIC_TITLES[twoLevel] ?? PageTitleService.STATIC_TITLES[oneLevel] ?? '');
  }
}
